export default __webpack_public_path__ + "static/media/clip-1692.44b54e69.png";